// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2gLuZ","choiceBoxes":"toolbarselects_choiceBoxes__2i4AB","simpleField":"toolbarselects_simpleField__2ZUtM"};